import {
  useContext, useState, useCallback, useEffect,
} from 'react';
import axios from 'axios';
import handleRequest from '../utils/handle-request';
import { persistSession, clearSession } from './session';
import { DispatchContext } from '../providers/AuthProvider';
import { DispatchMessageContext } from '../providers/MessageProvider';

async function login({ username, password }, cancelToken) {
  const method = 'post';
  const uri = '/service/v1/user/sign_in';
  const data = {
    email: username,
    password,
  };
  const config = {
    cancelToken,
  };
  const res = await handleRequest(method, uri, data, config);
  if (res && res.success && res.data && res.data.token) {
    persistSession(res.data.token);
  }
  return res;
}

async function logout() {
  clearSession();
  return { success: true };
}

function useLogin() {
  const dispatch = useContext(DispatchContext);
  const dispatchMessage = useContext(DispatchMessageContext);
  const [form, setForm] = useState({ username: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatchMessage({ type: 'reset' });
  }, [form]);

  const doLogin = useCallback(() => {
    const { CancelToken } = axios;
    const { token, cancel } = CancelToken.source();
    dispatchMessage({ type: 'reset' });

    const fetch = async () => {
      setIsLoading(true);
      const res = await login(form, token);
      setIsLoading(false);
      if (!res.success) {
        return dispatchMessage({ type: 'error', message: res.message });
      }
      return dispatch({ type: 'login' });
    };

    fetch();

    return () => cancel('component unmount');
  }, [form]);

  return [setForm, doLogin, isLoading];
}

function useLogout() {
  const dispatch = useContext(DispatchContext);
  const dispatchMessage = useContext(DispatchMessageContext);
  const [isLoading, setIsLoading] = useState(false);
  const doLogout = useCallback(() => {
    const { CancelToken } = axios;
    const { token, cancel } = CancelToken.source();

    const fetch = async () => {
      setIsLoading(true);
      const res = await logout(token);
      setIsLoading(false);
      if (!res.success) {
        return dispatchMessage({ type: 'error', message: res.message });
      }
      return dispatch({ type: 'logout' });
    };

    fetch();

    return () => cancel('component unmount');
  });

  return [doLogout, isLoading];
}

export { useLogin, useLogout };
